export default __webpack_public_path__ + "static/protester-7c5b6f9ee339234c83f2f0f8edd7c08f.svg";